import React, {useState} from 'react';
import styled from 'styled-components';
import {fontSize, tabletWidth} from '../../mixins';

const StyledSatellite = styled.button`
    position: absolute;
    top: ${props => props.topPosition || '56px'};
    right: 6px;
    z-index: 1000;
    background-color: transparent;
    border: none;
    display: grid;
    grid-row-gap: 2px;
    cursor: pointer;
   
  
    img {
      border-radius: 16px;
      width: 48px;
      height: 48px;
    }

    @media screen and (min-width: ${tabletWidth}) {
      right: 24px;
  
        img {
          width: 80px;
          height: 80px;
        }
        
    }
    
    span {
        width: 100%;
        ${fontSize(9)};
        line-height: 16px;
        position: absolute;
        bottom: 6px;
        left: 0;
        text-align: center;
        
         @media screen and (min-width: ${tabletWidth}) {
           ${fontSize(13)};
         }
    }
`

const ModeSwitcher = ({map, topPosition}) => {
    const [mode, setMode] = useState('roadmap');
    const [icon, setIcon] = useState('./images/Sat.png');

    const label = mode === 'roadmap' ? 'Satellite' : 'Street';

    const labelStyle = mode === 'roadmap' ? {color: '#fff'} : {color: '#212529'};


    const onModeClick = () => {
        if (mode === 'roadmap') {
            map.setOptions({mapTypeId: 'satellite'});
            setIcon('./images/Street.png');
            setMode('satellite');
            return;
        }

        map.setOptions({mapTypeId: 'roadmap'});
        setIcon('./images/Sat.png');
        setMode('roadmap');
    };

    return (
        <StyledSatellite topPosition={topPosition}>
            <img src={icon} onClick={onModeClick}/>
            <span style={labelStyle}>{label}</span>
        </StyledSatellite>
    )
}

export default ModeSwitcher;